import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Ref, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/monitor-center/lang/index';
import commonImg from '@blade-sxp/monitor-center/pages/components/carousel/common-img.vue';
let default_1 = class default_1 extends Vue {
    pictureBox;
    imgList;
    propData;
    margin = 0;
    isFour = false;
    maxNum = 0;
    showImg = [];
    mounted() {
        this.$nextTick(() => {
            this.resetView();
        });
        window.onresize = () => {
            return (() => {
                this.resetView();
            })();
        };
    }
    get curMargin() {
        return this.margin / 5;
    }
    resetView() {
        const pictureBoxWidth = this.pictureBox?.offsetWidth;
        // const pictureBoxHeight = this.pictureBox.offsetHeight;
        const num = parseInt(String(pictureBoxWidth / 120));
        // console.log('num', num);
        const pictureWidth = num * 120;
        this.maxNum = num * 4;
        // console.log('maxNum', this.maxNum);
        this.margin = (pictureBoxWidth - pictureWidth) / num / 2 - 2;
    }
    handleSnapRecord(snapImage) {
        const { startTime, endTime, deviceIdArr } = this.propData;
        // this.$router.push({
        //   path: '/businessPortal/snapRecord',
        //   query: {
        //     params: JSON.stringify({ deviceId: this.snapForm.deviceIds, startTime, endTime, image: snapImage.portraitImage }),
        //   },
        // });
        window.open(this.$router.resolve({
            path: '/monitorCenter/snapRecord',
            query: {
                params: JSON.stringify({ deviceId: deviceIdArr, startTime, endTime, image: snapImage.portraitImage }),
            },
        }).href, '_blank');
    }
    goPage() {
        const { deviceIdArr } = this.propData;
        this.$router.push({
            path: '/search/searchPage',
            query: {
                param: JSON.stringify({ deviceIdList: deviceIdArr }),
                type: 'monitor',
            },
        });
    }
    mouseLeave() {
        this.$emit('mouseLeaveOpen');
    }
    mouseEnter() {
        this.$emit('mouseEnterOpen');
    }
};
__decorate([
    Ref()
], default_1.prototype, "pictureBox", void 0);
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "propData", void 0);
default_1 = __decorate([
    Component({
        name: 'MsgAlarm',
        components: {
            'common-img': commonImg,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
